import React from "react";
import HeaderBanner from "../../Components/HeaderBanner/HeaderBanner";
import Stats from "../../Components/Stats/Stats";
import InstagramSlider from "../../Components/IGSection/IGSection";
import ValuesSection from "../../Components/ValuesSection/ValuesSection";
import WhyUs from "../../Components/WhyUs/WhyUs";
import TeamSection from "../../Components/Team/Team";
import FadeInWhenVisible from "../../Utilities/FadeInWhenVisible";

export default function AboutPage() {
  return (
    <div>
      <HeaderBanner title="About Us" currentPath="About Us" />
      <FadeInWhenVisible>
        <div className="about">
          <div className="about-left">
            <img
              src="https://images.unsplash.com/photo-1512436991641-6745cdb1723f"
              alt="about-img"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="about-right">
            <h6 className="small-header">Introducing Zakarry</h6>
            <h3>
              This is more than fashion; it’s our shared story, sewn with
              intention.
            </h3>
            <p>
              Zakarry was built the way every timeless piece is; from the inside
              out. It started with sketches in a notebook, experiments with
              fabric, and dresses made in between classes. While one sister
              honed her craft in fashion school, learning from videos, mentors,
              and her own hands, the other stood beside her; encouraging her and
              handling the details no one sees: styling, client care, branding,
              and direction.
            </p>
            <p>
              Together, we laid each brick of Zakarry from the ground up;
              building a brand rooted in trust, quality, and intentional design.
              Our earliest clients weren’t from campaigns; they were from
              presence, from the impact of a well-made piece worn with pride.
              That’s how Zakarry grew: through real people, real moments, and
              the power of recommendation.
            </p>
          </div>
        </div>
      </FadeInWhenVisible>
      <FadeInWhenVisible delay={0.4}>
        <Stats />
      </FadeInWhenVisible>
      <FadeInWhenVisible delay={0.4}>
        <ValuesSection />
      </FadeInWhenVisible>
      <FadeInWhenVisible delay={0.4}>
        <WhyUs />
      </FadeInWhenVisible>
      {/* <FadeInWhenVisible delay={0.4}>
        <TeamSection />
      </FadeInWhenVisible> */}
      <FadeInWhenVisible delay={0.4}>
        <InstagramSlider />
      </FadeInWhenVisible>
    </div>
  );
}
